import { Component, Host, h, Element, Prop, Event, EventEmitter } from '@stencil/core';

/**
 * @slot - Buttons to be rendered as a group.
 */
@Component({
  tag: 'sy-button-group',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class ButtonGroup {
  @Element() el: HTMLSyButtonGroupElement;

  private sizeObserver: MutationObserver;

  private resizeObserver: ResizeObserver;

  /**
   * If true, indicates component axis x overflow.
   */
  @Prop({ reflect: true, mutable: true }) overflow = false;

  /**
   * Emitted after sy-button-group overflow parent element's width.
   */
  @Event() syButtonGroupDidOverflow: EventEmitter<boolean>;

  private handleOverflow() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry?.target?.clientWidth && entry.target.scrollWidth) {
          if (!this.overflow && entry.target.scrollWidth > entry.target.clientWidth) {
            this.overflow = true;
            this.syButtonGroupDidOverflow.emit(this.overflow);
          } else if (this.overflow && entry.target.scrollWidth <= entry.target.clientWidth) {
            this.overflow = false;
            this.syButtonGroupDidOverflow.emit(this.overflow);
          }
        }
      }
    });

    this.resizeObserver.observe(this.el);

    this.sizeObserver = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (!this.overflow && this.el.scrollWidth > this.el.clientWidth) {
          this.overflow = true;
          this.syButtonGroupDidOverflow.emit(this.overflow);
        } else if (this.overflow && this.el.scrollWidth <= this.el.clientWidth) {
          this.overflow = false;
          this.syButtonGroupDidOverflow.emit(this.overflow);
        }
      });
    });
    this.sizeObserver.observe(this.el, { childList: true });
  }

  componentWillLoad() {
    this.handleOverflow();
  }

  disconnectedCallback() {
    if (this.el.isConnected) return;

    this.resizeObserver?.disconnect();
    this.sizeObserver?.disconnect();
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
